
export const SET_PIT = 'SET_PIT_INFO'

export const setPit = (pitInfo) => ({
  type: SET_PIT,
  pitInfo,
})
